import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';

import Form from '../../../../../components/Form/Form';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as formInputNames from '../../../../../consts/form/formInputNames';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import * as modalTypes from '../../../../../consts/modals/modalTypes';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import serviceArsService from '../../../../../services/services/serviceArsService';
import helpers from '../../../../../utils/helpers';
import arsOrganizationModalService from './arsOrganizationModalService';

const ArsOrganizationModal = (props) => {
    const {onOk, onCancel, modalType} = props;
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();

    let modalData = {};

    switch (modalType) {
        case modalTypes.ADD_ARS_ORGANIZATION_MODAL_TYPE: {
            modalData = arsOrganizationModalService.getAddArsOrganizationModalContent();
            break;
        }
        case modalTypes.EDIT_ARS_ORGANIZATION_MODAL_TYPE: {
            modalData = arsOrganizationModalService.getEditArsOrganizationModalContent();
            break;
        }

        default:
            break;
    }

    const {formContent, title, submitButton, cancelButton, initialValues, requireDeps} = modalData || {};

    useEffect(() => {
        document.body.classList.add('ars-organization-modal-open');

        return () => document.body.classList.remove('ars-organization-modal-open');
    }, []);

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            const formValues = values;

            helpers.runFunction(onOk, formValues);
        } catch (error) {
            log.error(`arsOrganizationModal - validate failed: ${error}`);
        }
    };

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }

        return () => {
            form.resetFields();
        };
    }, []);

    const resetFormField = (fieldNames) => {
        const fieldsToReset = {};

        fieldNames.forEach((name) => (fieldsToReset[name] = null));
        form.setFieldsValue(fieldsToReset);
    };

    const setFormField = (name, key, value) => form.setFieldsValue({[name]: {id: key, value}});

    const handleRadioChange = (value, name) => {
        form.setFieldsValue({[name]: value});

        switch (name) {
            case formInputNames.SOURCE: {
                resetFormField([formInputNames.FOLDER, formInputNames.LOGIN, formInputNames.PASSWORD]);

                break;
            }
        }
    };

    const handleSelect = async (value, name, option) => {
        const currentValue = form.getFieldValue(name);

        if (currentValue?.value === option.value) return;

        setFormField(name, option.key, option.value);

        switch (name) {
            case formInputNames.CITY: {
                resetFormField([formInputNames.ORGANIZATION, formInputNames.ALL_BUILDINGS]);

                await serviceArsService.getArsUnappliedOrganizationsNames(value);
                break;
            }
            case formInputNames.ORGANIZATION: {
                resetFormField([formInputNames.ALL_BUILDINGS]);

                break;
            }
            case formInputNames.REPORT_TYPE: {
                resetFormField([formInputNames.DEVICE_GROUP]);

                break;
            }

            default:
                break;
        }
    };

    const handleChange = () => {};

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName='ars-organization-settings'
                title={title}
                closeLabel={strings[localizationKeys.SERVICES_MOBILE_CLOSE]}
                onCancel={onCancel}
                formFields={formContent.map((field) => ({
                    ...field,
                    hidden:
                        typeof field.hidden === 'function'
                            ? (values) => field.hidden(undefined, values[field.itemDeps])
                            : field.hidden,
                }))}
                initialValues={initialValues}
                onFinish={onFinish}
                submitButton={submitButton}
                cancelButton={cancelButton}
                handleChange={handleChange}
                handleSelect={handleSelect}
                handleRadioChange={handleRadioChange}
                requireDeps={requireDeps}
            />
        );
    }

    return (
        <Form
            handleRadioChange={handleRadioChange}
            handleSelect={handleSelect}
            closeModal={onCancel}
            initialValues={initialValues}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formContent}
            cancelButton={cancelButton}
            formInstance={form}
            requireDeps={requireDeps}
            handleChange={handleChange}
            formClassName='ars-organization-form'
            containerClassName='ars-organization-form-content'
            buttonsClassName='ars-organization-form-actions'
        />
    );
};

export default React.memo(ArsOrganizationModal);
